import { BACK_SEARCH_PARAM } from 'src/js/constants/common';

const isBackPlatformAvailable = () => {
  const parsedUrl = new URL(window.location.href);

  return !!parsedUrl.searchParams.get(BACK_SEARCH_PARAM);
};

export default isBackPlatformAvailable;
